import React, { memo, useCallback, useMemo } from 'react';
import Animated, { withTiming, useAnimatedStyle, } from 'react-native-reanimated';
import { InteractionManager, View } from 'react-native';
import Text from 'design-system/Text';
import { hitSlop, rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { triggerTimePeriodChange } from 'utils/hapticFeedback';
import { eachCharacterWidth, horizontalPadding } from './constants';
const TimePeriod = ({ period, periods, viewWidth, isSelected, scrollViewRef, selectedPeriod, activeTextColor, setSelectedPeriod, darkActiveIndicator, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const animatedTextStyle = useAnimatedStyle(() => ({
        opacity: withTiming(period === selectedPeriod || isSelected ? 1 : 0),
    }), [isSelected, period, selectedPeriod]);
    const animatedLabelStyle = useAnimatedStyle(() => ({
        opacity: withTiming(period === selectedPeriod || isSelected ? 0 : 1),
    }), [isSelected, period, selectedPeriod]);
    const handlePeriodSelect = useCallback(() => {
        InteractionManager.runAfterInteractions(() => {
            setSelectedPeriod(period);
            triggerTimePeriodChange();
            if (viewWidth && scrollViewRef) {
                const periodsLength = periods?.length;
                if (periodsLength) {
                    const index = periods.findIndex((item) => item === period);
                    if (index !== -1) {
                        const finalIndex = (() => {
                            if (index < 0.5 * periodsLength) {
                                return Math.max(0, index - 1);
                            }
                            return Math.min(periodsLength, index + 1);
                        })();
                        scrollViewRef.current?.scrollTo({
                            x: finalIndex * viewWidth,
                            animated: true,
                        });
                    }
                }
            }
        });
    }, [period, periods, scrollViewRef, setSelectedPeriod, viewWidth]);
    const textColor = useMemo(() => {
        if (activeTextColor)
            return { color: activeTextColor };
        if (darkActiveIndicator)
            return { color: colors.background.light };
        return { White: true };
    }, [activeTextColor, colors.background.light, darkActiveIndicator]);
    return (<View style={styles.container}>
      <TouchableBounce hitSlop={hitSlop} style={[
            styles.periodBtn,
            { width: period.length * eachCharacterWidth + horizontalPadding },
        ]} onPress={handlePeriodSelect} hoverStyle={styles.hoverStyles}>
        <Animated.View style={animatedLabelStyle}>
          <Text Text-14 Secondary>
            {period}
          </Text>
        </Animated.View>
      </TouchableBounce>
      <View style={styles.absView} pointerEvents="none">
        <Animated.View style={animatedTextStyle}>
          <Text Text-14 {...textColor}>
            {period}
          </Text>
        </Animated.View>
      </View>
    </View>);
};
export default memo(TimePeriod);
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingVertical: rem(16),
    },
    periodBtn: {
        height: rem(25),
        alignItems: 'center',
        borderRadius: rem(8),
        justifyContent: 'center',
    },
    absView: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
    },
    hoverStyles: {
        backgroundColor: colors.control.hoverOnLight,
    },
}));
